const paginatorConfig = {
    LIMIT: 10
};

export default paginatorConfig;
